export const fwsed = {
  routes: [
    {
      path: "/fwsed/firm-management/:firmId/audit",
      component: () => import("../firm-audit"),
      props: true,
    },
    {
      path: "/fwsed/firm-management/:firmId/audit/:auditId/question-sets",
      component: () => import("../firm-audit-question-set"),
      props: true,
    },
  ],
};
